import Vue from 'vue';

Vue.component('vuetable_voided', () =>
    import(/* webpackChunkName: 'voided' */ './vuetable_voided.vue'),
);

Vue.component('voided-sales-summary', () =>
    import(/* webpackChunkName: 'voided' */ './boxSummary.vue'),
);

Vue.component('voided-orders', () =>
    import(/* webpackChunkName: 'voided' */ './voided-orders.vue'),
);

Vue.component('aborted-fuel', () =>
    import(/* webpackChunkName: 'voided' */ './aborted-fuel-datatable.vue'),
);
